import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Map from '../Maps/Map.js';
import Map2 from '../Maps/Map2.js';
import Home from '../Home/Home.js';
import NotFound from '../ErrorPages/NotFound.js';

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* <Route path="mapOld">
        <Route index element={<Navigate to="/" replace />} />
        <Route path="la-union" element={<Navigate to="/map/La Unión 12-24" replace />} />
        <Route path=":projectCode" element={<Map />} />
      </Route> */}
      <Route path="map">
        <Route index element={<Navigate to="/" replace />} />
        <Route path="la-union" element={<Navigate to="/map/La Unión 12-24" replace />} />
        <Route path=":projectCode" element={<Map2 />} />
      </Route>
      <Route path="*" element={ <NotFound /> } />
    </Routes>
  )
}

export default Routing;